
import { Vue, Component, toNative } from 'vue-facing-decorator';
import Groups from '@/components/Participants/Groups/Groups.vue';
import { Root } from '@/main';

@Component({
  components: { Groups },
})
class GroupsView extends Vue {
  private mounted() {
    Root.emit('set-active-component', 'groups');
  }
}

export default toNative(GroupsView);
